export var SchedulesUsageItemType;
(function (SchedulesUsageItemType) {
    SchedulesUsageItemType["LINE"] = "LINE";
    SchedulesUsageItemType["QUEUE"] = "QUEUE";
    SchedulesUsageItemType["RULE"] = "RULE";
    SchedulesUsageItemType["SLA_POLICY"] = "SLA_POLICY";
    SchedulesUsageItemType["WIDGET"] = "WIDGET";
})(SchedulesUsageItemType || (SchedulesUsageItemType = {}));
export var schedulesApiRelativePath = "/schedules";
export var downtimeApiRelativePath = "/downtimes";
export var duplicateApiRelativePath = "/duplicate";
export var createSchedulesApi = function (baseUrl, http) {
    var schedulesApiUrl = "" + baseUrl + schedulesApiRelativePath;
    return {
        getTenantSchedules: function () { return http.get("" + schedulesApiUrl); },
        addTenantSchedule: function (dto) { return http.post("" + schedulesApiUrl, dto); },
        getTenantSchedule: function (dto) { return http.get(schedulesApiUrl + "/" + dto.id); },
        updateTenantSchedule: function (dto) { return http.put(schedulesApiUrl + "/" + dto.id, dto); },
        deleteTenantSchedule: function (dto) { return http.delete(schedulesApiUrl + "/" + dto.id); },
        duplicateTenantSchedule: function (dto) { return http.post(schedulesApiUrl + "/" + dto.id + duplicateApiRelativePath, dto); },
        getScheduleUsage: function (dto) { return http.get(schedulesApiUrl + "/" + dto.id + "/relations"); },
        getSchedulesUsageCount: function () { return http.get(schedulesApiUrl + "/relations/count"); },
        getScheduleDowntimes: function (scheduleId) { return http.get(schedulesApiUrl + "/" + scheduleId + downtimeApiRelativePath); },
        getScheduleDowntime: function (scheduleId, downtimeId) { return http.get(schedulesApiUrl + "/" + scheduleId + downtimeApiRelativePath + "/" + downtimeId); },
        addScheduleDowntime: function (dto) { return http.post(schedulesApiUrl + "/" + dto.scheduleId + downtimeApiRelativePath, dto); },
        updateScheduleDowntime: function (dto) { return http.put(schedulesApiUrl + "/" + dto.scheduleId + downtimeApiRelativePath + "/" + dto.id, dto); },
        deleteScheduleDowntime: function (dto) { return http.delete(schedulesApiUrl + "/" + dto.scheduleId + downtimeApiRelativePath + "/" + dto.id); },
    };
};
//# sourceMappingURL=index.js.map